import { useSelector } from 'react-redux';
import SwalAlert from '../alert';

const PermissionWrapper = ({ permission, children }) => {
	const menu = useSelector((state) => state.menuData);
	if (menu) {
		try {
			// console.log(menu)
			// console.log(permission)
			// SwalAlert.error("You don't have permission to access this page",JSON.stringify(menu))
			if (!menu.data.includes(permission)) return null
		} catch {
			return null;
		}
	}
	return children;
};
export default PermissionWrapper;
